// Port of api/fuel/app/classes/filter/package/games/play/prepare/games/winpercent.php
import F from 'offline/filter/constants'
export default {
	require: function(config, filter) { return config.ownerType === F.OWNER_USER && filter.play && filter.play.group },
	run: function(local, global) {
		local.record = {
			plays: 0,
			wins: 0
		}

		var record = global.record && global.record[local.game_id] ? global.record[local.game_id] : null
		if (record) {
			local.record.results = parseInt(record.r, 10) || 0
			local.record.plays = parseInt(record.p, 10) || 0
			local.record.wins = parseInt(record.w, 10) || 0
		}

		return local
	}
}
